import { render, staticRenderFns } from "./DrawerLoader.vue?vue&type=template&id=9f887c44&scoped=true&"
import script from "./DrawerLoader.vue?vue&type=script&lang=js&"
export * from "./DrawerLoader.vue?vue&type=script&lang=js&"
import style0 from "./DrawerLoader.vue?vue&type=style&index=0&id=9f887c44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f887c44",
  null
  
)

export default component.exports